import moment, { unitOfTime } from 'moment';
import _ from 'underscore';
import $ from 'jquery';
import { Element as RustigElement } from './element';
import { DateField } from '../modules/datefield';

export class DateExpression {
  private static sourceSelector = 'date-expression';
  private static targetSelector = 'de-target';

  public static get wireup() {
    return DateExpression.sourceSelector.asDataSelector();
  }

  $element: JQuery;
  $datefield: DateField;
  $key: string;

  public constructor($element: JQuery) {
    this.$element = $element;
    this.$datefield = this.$element.data('rustig.datefield');
    this.$key = this.$element.data(DateExpression.sourceSelector);

    if (this.$key === undefined)
      throw new Error('Rustig.DateExpression requires a key');

    this.registerEvents();
  }

  registerEvents() {
    let eventString = this.$element.data('de-trigger');

    this.$element.on(eventString, this.onInputChange.bind(this));
  }

  onInputChange(e: JQueryEventObject) {
    const format = this.$datefield?.dateFormat?.pickerDateFormat;
    const sourceValue = moment(this.$element.val(), format);

    if (!sourceValue.isValid())
      return;

    const $targets = $(DateExpression.targetSelector.asDataSelector(this.$key));

    $targets
      .each((_, element) => {
        const $element = $(element);
        const value = parseInt($element.data('de-value'));
        const unit = $element.data('de-unit') ?? 'd' as unitOfTime.Base;

        if (isNaN(value))
          throw new Error('Rustig.DateExpression requires a value.');

        const newValue = sourceValue.clone().add(value, unit).toDate();

        new RustigElement($element).value(newValue);
      });
  }
}

function Plugin(): void {
  return this.each(function () {
    let $this = $(this);
    let data = $this.data('rustig.dateexpression');

    if (!data) {
      data = new DateExpression($this);
      $this.data('rustig.dateexpression', data);
    }
  })
}

declare global {
  interface JQuery {
    dateexpression: () => any;
  }
}

$.fn.dateexpression = Plugin;
